// src/supabaseClient.js — Super Admin Dashboard
//
// GoTrue-login-cutover task (2026-07-06): replaces Firebase Auth
// (signInWithEmailAndPassword/onAuthStateChanged/signOut from 'firebase/auth')
// as the super-admin's login mechanism. This client is used ONLY for
// authentication (`supabase.auth.*`) — this dashboard has NO direct
// Postgres/PostgREST table access of its own; every data operation still
// goes through the Express backend (`confirming-app.dafaiagency.shop/api/
// super-admin/*`, see src/utils/superAdminApi.js), sent as a Bearer token
// built from `supabase.auth.getSession()`'s `access_token`.
//
// Same backing GoTrue/Supabase instance the Daf Confirmation merchant
// dashboard already uses (see confirming-order-dashboard-api/src/
// supabaseClient.js) and the same instance `daf_confirmation.super_admins`
// lives in.
//
// URL + anon key are PUBLIC, browser-safe values (same trust model as
// Firebase's `apiKey` in the old src/firebase.js — never a secret, safe to
// ship in the bundle) — hardcoded here on purpose, matching this project's
// existing convention (see src/firebase.js's `firebaseConfig`) instead of
// requiring a `.env.local` file that has to be recreated on every fresh
// checkout/deploy box.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://supabase-daf-one.dafaiagency.shop';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzgyOTQzNzk1LCJleHAiOjIwOTgzMDM3OTV9.DjkVdDmOjUJk-uNeAQX3HmqEnI__m1S-Be-Ifl8lScQ';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Not an OAuth-redirect consumer — plain email+password login.
    detectSessionInUrl: false,
    // Isolated storage key so this client's session never collides with the
    // merchant dashboard's own supabase-js session (`daf-confirmation-auth`)
    // or any other DAF app's GoTrue session, even if ever opened in the same
    // browser profile.
    storageKey: 'daf-super-admin-auth',
  },
});

export default supabase;
